import React, { useState, useEffect } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import theme from "theme";
import SC from "./style";

const ProjectSection = (props) => {
  const { items, title, onSelectionChange, selectedItems } = props;

  const [selectAll, setSelectAll] = useState(false);
  const [filteredProjectData, setFilteredProjectData] = useState(items);

  // Update filtered list when items change
  useEffect(() => {
    setFilteredProjectData(items);
  }, [items]);

  // Effect to update selectAll based on selectedItems
  useEffect(() => {
    const selectData =
      selectedItems.length > 0 && selectedItems.length === items.length;
    setSelectAll(selectData);
  }, [selectedItems, items.length]);

  const handleSelectAllChange = () => {
    setSelectAll((prevSelectAll) => {
      const newSelectAllState = !prevSelectAll;

      if (newSelectAllState) {
        const allRoleIds = filteredProjectData.map((item) => item.id);
        onSelectionChange(allRoleIds, true);
      } else {
        onSelectionChange("clear", false);
      }

      return newSelectAllState;
    });
  };

  const handleSearch = (event) => {
    const query = event.target.value.trimStart();
    if (query === "") {
      setFilteredProjectData(items);
      return;
    }

    const newData = items.filter(
      (item) =>
        item.propertyName &&
        item.propertyName.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredProjectData(newData);
  };

  return (
    <Box>
      <>
        {items.length === 0 ? (
          <Typography
            sx={{
              padding: "20px",
              textAlign: "center",
              fontSize: "14px",
              color: theme.colors.grey,
            }}
          >
            No project linked
          </Typography>
        ) : (
          <>
            {title && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ flexGrow: 1, textAlign: "left" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                        sx={{
                          "&.Mui-checked": {
                            color: theme.colors.themeColor,
                          },
                        }}
                        size="small"
                      />
                    }
                    label={<span style={{ fontWeight: "bold" }}>{title}</span>}
                  />
                </Typography>

                <SC.InputContiner>
                  <SC.SearchIcon />
                  <SC.InputStyle
                    placeholder="Search by project name"
                    onChange={handleSearch}
                  />
                </SC.InputContiner>
              </Box>
            )}
            <Divider />
            <List sx={{ display: "flex", flexWrap: "wrap" }}>
              {filteredProjectData.map((item) => (
                <ListItem
                  key={item.id}
                  disablePadding
                  sx={{ width: "calc(25% - 0px)" }}
                >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedItems.includes(item.id)}
                          onChange={() => onSelectionChange(item.id)}
                          sx={{
                            "&.Mui-checked": {
                              color: theme.colors.themeColor,
                            },
                          }}
                          size="small"
                        />
                      }
                      label={
                        <span style={{ fontSize: "12px" }}>
                          {item?.propertyName}
                        </span>
                      }
                    />
                  </FormGroup>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </>
    </Box>
  );
};

export default ProjectSection;
